import { z } from 'zod';

export const workspaceResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  use_type: z.string().nullable(),
  created_at: z.string().nullable(),
  updated_at: z.string().nullable()
});
